// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2Riye","actionsCol":"EnrolledClinics_actionsCol__2tooO"};